module.exports = __webpack_public_path__ + "src/app/_content/imgs/icons/brake_pads.png?fdc17be93c0bd0224e47941a1c6728b7";